import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    backButtonLabel: (projectName: string) => string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            backButtonLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (projectName: string): string => __intl__.intl().formatMessage({ id: "ProjectHeaderBackButton.backButtonLabel?c=18kgn0m884h70", defaultMessage: "Back to {projectName}" }, { projectName: projectName }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
